import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white border-t-2 border-military-accent">
      <div className="max-w-7xl mx-auto px-4">
        {/* Main Footer Content */}
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <div className="text-2xl md:text-3xl font-black tracking-tighter mb-4 text-gradient-military">
                  CENTRON
                </div>
                <div className="text-xs md:text-sm font-military-mono tracking-widest uppercase text-military-silver mb-4">
                  AEROSPACE & DEFENSE LLC
                </div>
              </div>
              <p className="text-military-silver mb-8 max-w-md font-military-mono text-xs md:text-sm leading-relaxed">
                {t('footer.description', 'Leading provider of advanced aerospace and defense engineering solutions, delivering innovative technology for national security and global advancement.')}
              </p>
              <div className="flex flex-wrap gap-3">
                <a href="mailto:sales@centronaero.com" className="btn-military-outline text-xs md:text-sm">
                  EMAIL
                </a>
                <a href="tel:+971524657009" className="btn-military-outline text-xs md:text-sm">
                  CALL
                </a>
                <a href="https://www.linkedin.com/company/centron-aerospace-and-engineering/" target="_blank" rel="noopener noreferrer" className="btn-military-outline text-xs md:text-sm">
                  LINKEDIN
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-base md:text-lg font-black tracking-tighter mb-6 uppercase text-military-accent">{t('footer.quickLinks', 'Quick Links')}</h4>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <Link to="/about" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    {t('nav.about')}
                  </Link>
                </li>
                <li>
                  <Link to="/vision-mission" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    {t('nav.vision')}
                  </Link>
                </li>
                <li>
                  <Link to="/uav-platform" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    UAV Platform
                  </Link>
                </li>
                <li>
                  <Link to="/rd" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    R&D
                  </Link>
                </li>
                <li>
                  <Link to="/products" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    {t('nav.products')}
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    {t('nav.contact')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Products & Services */}
            <div>
              <h4 className="text-base md:text-lg font-black tracking-tighter mb-6 uppercase text-military-accent">{t('footer.productsServices', 'Products & Services')}</h4>
              <ul className="space-y-2 md:space-y-3">
                <li>
                  <Link to="/uav-platform" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    Tactical UAV
                  </Link>
                </li>
                <li>
                  <Link to="/rd" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    UAV Fighter
                  </Link>
                </li>
                <li>
                  <Link to="/rd" className="text-military-silver hover:text-military-accent font-bold text-xs md:text-sm tracking-wider uppercase transition-all duration-300 block py-1">
                    Cruise Missiles
                  </Link>
                </li>
              </ul>
            </div>


          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-military-accent/30 py-6 md:py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-military-silver text-xs md:text-sm font-military-mono text-center md:text-left">
              {t('footer.copyright', `© ${currentYear} Centron Aerospace and Defense SRO. All rights reserved.`)}
            </div>
            <div className="flex space-x-4 md:space-x-6 text-xs md:text-sm">
              <Link to="/privacy" className="text-military-silver hover:text-military-accent font-bold tracking-wider uppercase transition-all duration-300">
                {t('footer.privacy')}
              </Link>
              <Link to="/terms" className="text-military-silver hover:text-military-accent font-bold tracking-wider uppercase transition-all duration-300">
                {t('footer.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 